import type { SVGProps } from 'react';
const SvgViewQuilt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#view_quilt_svg__a)">
      <path
        fill="currentColor"
        d="M10 18h5v-6h-5v6Zm-6 0h5V5H4v13Zm12 0h5v-6h-5v6ZM10 5v6h11V5H10Z"
      />
    </g>
    <defs>
      <clipPath id="view_quilt_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgViewQuilt;
